export default __webpack_public_path__ + "static/media/power.a186b439.jpg";